import type { OnboardingStepKey } from '../../config/onboardingRegistry'
import {
  isOfferMgmtHubStep,
  isOnboardingGuideCoreComplete,
  isOptionalGuideStep,
  isPostGuideStep,
  nextGuidedStepKey,
  ONBOARDING_GUIDE_SEQUENCE,
  ONBOARDING_OFFER_MGMT_STEPS,
  ONBOARDING_OPTIONAL_STEP_KEYS,
  ONBOARDING_POST_GUIDE_STEP_KEYS,
  previousGuidedStep,
} from './onboardingGuideConfig'

export {
  isOfferMgmtHubStep,
  ONBOARDING_OFFER_MGMT_STEPS,
  previousGuidedStep,
}

/** Akcje bulk w zarządzaniu ofertami powiązane z krokami onboardingu. */
export type OnboardingBulkActionId =
  | 'titles'
  | 'descriptions'
  | 'graphics'
  | 'parameters'
  | 'images'
  | 'copy'

/** images is not a guide step — locked during core journey via missing map entry. */
export const ONBOARDING_BULK_ACTION_STEP: Partial<
  Record<OnboardingBulkActionId, OnboardingStepKey>
> = {
  titles: 'titles_flow',
  descriptions: 'descriptions_flow',
  graphics: 'grafikomat_flow',
  parameters: 'parameters_flow',
  copy: 'copy_offer',
}

export function parseOnboardingStepParam(search: string): OnboardingStepKey | null {
  const raw = new URLSearchParams(search).get('onboardingStep')
  if (!raw) return null
  const key = raw as OnboardingStepKey
  if (ONBOARDING_GUIDE_SEQUENCE.includes(key)) return key
  if (ONBOARDING_OPTIONAL_STEP_KEYS.includes(key)) return key
  if (ONBOARDING_POST_GUIDE_STEP_KEYS.includes(key)) return key
  return null
}

/**
 * Bulk deep-links: only current/next guide step (stricter than sidebar).
 * Completed steps stay locked here so OM can't re-burn credits mid-journey.
 */
export function isGuidedBulkActionEnabled(
  action: OnboardingBulkActionId,
  journeyLocksActive: boolean,
  currentStep: OnboardingStepKey | null,
  completedKeys: Set<OnboardingStepKey> = new Set(),
): boolean {
  if (!journeyLocksActive) return true
  const actionStep = ONBOARDING_BULK_ACTION_STEP[action]
  // images (and any unmapped action) stay locked during the core journey
  if (!actionStep) return false
  if (
    (isPostGuideStep(actionStep) || isOptionalGuideStep(actionStep)) &&
    !isOnboardingGuideCoreComplete(completedKeys)
  ) {
    return false
  }
  const nextStep = nextGuidedStepKey(completedKeys)
  return actionStep === nextStep || actionStep === currentStep
}
